import { useLocalStorage } from "@mantine/hooks"

export function useUserOption(name: string, defaultValue?: any) {
  const [value, setValue, remove] = useLocalStorage<any>({
    key: `tt-user-option:${name}`,
    defaultValue,
    serialize: (value) => JSON.stringify(value),
    deserialize: (value) => {
      try {
        return JSON.parse(value ?? "")
      } catch {
        return defaultValue
      }
    },
  })
  return [value ?? defaultValue, setValue, remove]
}
